<p>client-redirect works!</p>
